import { Box, Typography } from '@creditas-ui/react'
import React from 'react'
import { formatMoney } from 'shared/helpers'
import { ContentResumeDetailStyle } from './ContentResumeDetail.styles'
import {
  CustomTypography,
  ItemInformationDetail,
} from 'homepage/presentation/components/AccordionDetails/ContentResumeDetail/ContentResumeDetailHomeFin.styles'

const ContentResumeDetailHomeFin = ({ id, lead, ...props }) => {
  return (
    <ContentResumeDetailStyle component="div" {...props}>
      <CustomTypography
        mb="24px"
        component="h2"
        variant="bodyMdBold"
        color="neutral.80"
      >
        Resumo da solicitação
      </CustomTypography>
      <Box spaceY="20px">
        <ItemInformationDetail>
          <Box spaceY="8px">
            <Typography
              component="p"
              variant="bodySmRegular"
              color="neutral.80"
            >
              Valor solicitado
            </Typography>
            <Typography
              color="neutral.90"
              component="span"
              variant="headingSmMedium"
            >
              {lead?.financingValue
                ? formatMoney(parseInt(lead?.financingValue))
                : '--'}
            </Typography>
          </Box>

          {lead?.confirmedValue && (
            <Box spaceY="8px">
              <Typography
                component="p"
                variant="bodySmRegular"
                color="neutral.80"
              >
                Valor aprovado
              </Typography>
              <Typography
                color="primary.90"
                component="span"
                variant="headingSmMedium"
              >
                {formatMoney(parseInt(lead?.confirmedValue))}
              </Typography>
            </Box>
          )}
        </ItemInformationDetail>
        <Box spaceY="8px">
          <Typography component="p" variant="bodySmRegular" color="neutral.80">
            {lead?.stepName}
          </Typography>
          <Typography
            color="neutral.90"
            component="span"
            variant="bodyMdMedium"
          >
            {lead?.substepName}
          </Typography>
        </Box>
        {!lead?.confirmedValue && (
          <Box spaceY="8px">
            <Typography
              component="p"
              variant="bodySmRegular"
              color="neutral.80"
            >
              Enviamos a proposta aos nossos bancos parceiros. Em breve
              entraremos em contato com o resultado da análise de crédito
            </Typography>
          </Box>
        )}
      </Box>
    </ContentResumeDetailStyle>
  )
}

export { ContentResumeDetailHomeFin }
